import type { ThemeOptions } from '@mui/material';

export const spacing: ThemeOptions['spacing'] = 8;
